
function CancleBillValidate(values) {

    let errors = {};
    if (!values.Details)
        errors.Details = 'Details is required';

    return errors;
};

export default CancleBillValidate;
